module.exports = __webpack_public_path__ + "images/iphone/button_clicked.png";